<template>
  <nav class="navbar navbar-expand-lg navbar-light bg-light sticky-top" :class="{ 'shadow-sm': !showShadow }">
    <div class="container">
      <!-- TOP RESPONSIVE ACTIONS -->
      <button class="btn btn-link text-body ripple ripple-primary d-block d-lg-none" @click="toggleToolsDropdown">
        <i class="material-icons-outlined">&#xe5d2;</i>
      </button>
      <router-link to="/" class="navbar-brand">
        <img src="@/assets/img/logos/logo-form.svg" width="60px" height="60px" class="img-fluid img-logo"
             alt="Colorffy Logo">
      </router-link>
      <button v-if="user.loggedIn" class="btn btn-link text-body ripple ripple-primary d-block d-lg-none"
              @click="toggleUserDropdown">
        <img v-if="user.data.photoURL" :src="user.data.photoURL" class="img-fluid border-radius-50" width="24px"
             :alt="user.data.displayName + ' profile picture'">
        <i v-else class="material-icons-outlined">&#xe853;</i>
      </button>
      <router-link v-else to="/login" class="btn btn-link text-body ripple ripple-primary d-block d-lg-none">
        <i class="material-icons-outlined">&#xe853;</i>
      </router-link>
      <!-- NAVBAR CONTENT LG -->
      <div class="collapse navbar-collapse" id="navbarNavDropdown">
        <ul class="navbar-nav me-auto d-none d-lg-block">
          <li class="nav-item">
            <div>
              <input type="checkbox" class="btn-check" id="btn-check-nav" autocomplete="off" v-model="darkMode">
              <label class="btn btn-link btn-micint-rotate ripple ripple-primary m-0" for="btn-check-nav">
                <i class="material-icons-outlined" :class="[ darkMode ? 'text-warning' : 'text-muted']">
                  {{ darkMode ? '&#xe3aa;' : '&#xe51c;' }}</i>
              </label>
            </div>
          </li>
        </ul>
        <ul class="navbar-nav ms-auto">
          <li class="nav-item">
            <router-link to="/" class="nav-link" aria-current="page">Home</router-link>
          </li>
          <li class="nav-item">
            <router-link to="/palettes" class="nav-link">Palettes</router-link>
          </li>
          <li class="nav-item">
            <router-link to="/gradients" class="nav-link">Gradients</router-link>
          </li>

          <li class="nav-item">
            <a class="nav-link nav-menu-button" @click="toggleToolsDropdown">Tools</a>
          </li>

          <template v-if="user.loggedIn && rank === 2">
            <li class="nav-item dropdown">
              <a class="nav-link dropdown-toggle" href="#" id="dropdownAdmin" role="button"
                 data-bs-toggle="dropdown" aria-expanded="false">
                Admin Panel
              </a>
              <ul class="dropdown-menu dropdown-menu-end" aria-labelledby="dropdownAdmin">
                <li>
                  <router-link to="/admin/palettes" class="dropdown-item">
                    <i class="material-icons-outlined me-2">&#xe8b8;</i>
                    Palettes Panel
                  </router-link>
                </li>
                <li>
                  <router-link to="/admin/gradients" class="dropdown-item">
                    <i class="material-icons-outlined me-2">&#xe8b8;</i>
                    Gradients Panel
                  </router-link>
                </li>
              </ul>
            </li>
          </template>

          <template v-if="user.loggedIn">
            <li class="nav-item">
              <a class="nav-link nav-menu-button" @click="toggleUserDropdown">
                {{ user.data.displayName || 'Profile' }}
              </a>
            </li>
          </template>
          <template v-else>
            <li class="nav-item">
              <router-link to="/login" class="nav-link">Sign In</router-link>
            </li>
            <li class="nav-item">
              <router-link to="/sign-up" class="nav-link btn-primary text-center border-radius-8 ripple px-3 ">
                Register
              </router-link>
            </li>
          </template>

        </ul>
      </div>
    </div>
    <!-- DROPDOWNS -->
    <DropdownTools :is-dropdown-active="isDropdownActive"
                   :toggle-dropdown="toggleToolsDropdown"></DropdownTools>
    <DropdownUser :is-dropdown-user-active="isDropdownUserActive"
                  :toggle-user-dropdown="toggleUserDropdown" :user="user" :sign-out="signOut"></DropdownUser>
  </nav>
</template>

<script>
import firebase from 'firebase/app'
import 'firebase/auth'
import {mapGetters} from 'vuex'
import DropdownTools from "@/components/includes/DropdownTools";
import DropdownUser from "@/components/includes/DropdownUser";

export default {
  name: 'Navbar',
  components: {DropdownUser, DropdownTools},
  data() {
    return {
      showShadow: true,
      lastScrollPosition: 0,
      isDropdownActive: false,
      isDropdownUserActive: false,
    }
  },
  mounted() {
    window.addEventListener('scroll', this.onScroll)
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.onScroll)
  },
  methods: {
    toggleToolsDropdown() {
      this.isDropdownActive = !this.isDropdownActive
    },
    toggleUserDropdown() {
      this.isDropdownUserActive = !this.isDropdownUserActive
    },

    onScroll() {
      const currentScrollPosition = window.pageYOffset || document.documentElement.scrollTop
      if (currentScrollPosition < 0) {
        return
      }
      // Stop executing this function if the difference between
      // current scroll position and last scroll position is less than some offset
      if (Math.abs(currentScrollPosition - this.lastScrollPosition) < 60) {
        return
      }

      this.showShadow = currentScrollPosition < this.lastScrollPosition
      this.lastScrollPosition = currentScrollPosition
    },
    signOut() {
      firebase.auth()
          .signOut()
          .then(() => {
            this.$router.replace({
              name: "Home"
            });
          });
    },
  },
  computed: {
    ...mapGetters(['user', 'rank']),
    darkMode: {
      get() {
        return this.$store.getters.darkMode
      },
      set(newValue) {
        this.$store.commit("SET_DARK_MODE", newValue)
      }
    }
  },
}
</script>